import { useMutation, useQueryClient } from "@tanstack/react-query"
import { extractApiErrorMessage } from "@velizhanin-dev/api-errors"
import { MAX_BROADCAST_NAME_LENGTH } from "@velizhanin-dev/bot-scenario"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import type { AudienceFilter } from "@/entities/audience"
import { broadcastKeys, createBroadcast, updateBroadcast } from "@/entities/broadcast"

/**
 * Рассылка по тем, кого сейчас видно в списке: черновик сразу с этим фильтром.
 * После создания открывается редактор, отправить можно только оттуда.
 */
export function useStartBroadcast(botId: string) {
	const navigate = useNavigate()
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: async ({ name, filter }: { name: string; filter: AudienceFilter }) => {
			const title = name.length > MAX_BROADCAST_NAME_LENGTH
					? `${name.slice(0, MAX_BROADCAST_NAME_LENGTH - 1)}…`
					: name
			const created = await createBroadcast(botId, { name: title })
			return updateBroadcast(botId, created.id, { filter })
		},
		onSuccess: async (broadcast) => {
			queryClient.setQueryData(broadcastKeys.detail(botId, broadcast.id), broadcast)
			await queryClient.invalidateQueries({ queryKey: broadcastKeys.list(botId) })
			navigate(`/admin/bots/${botId}/broadcasts/${broadcast.id}`)
		},
		onError: (error) => toast.error(extractApiErrorMessage(error, "Не удалось создать рассылку")),
	})
}
